import api from "../api";

export const getNotifications = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/notifications", { params });
};

export const getNotification = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/notifications/${id}`);
};

export const getNotificationStats = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/notifications/stats", { params });
};

export const createNotification = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "admin/notifications", data);
};

export const bulkCreateNotifications = async (userIds, title, message, type, actionUrl) => {
  return api.getApi().post(api.getBaseUrl() + "admin/notifications/bulk", {
    userIds,
    title,
    message,
    type,
    actionUrl
  });
};

export const markNotificationAsRead = async (id) => {
  return api.getApi().patch(api.getBaseUrl() + `admin/notifications/${id}/read`);
};

export const markAllNotificationsAsRead = async (userId) => {
  return api.getApi().patch(api.getBaseUrl() + `admin/notifications/user/${userId}/read-all`);
};

export const deleteNotification = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/notifications/${id}`);
};

export const getUserNotifications = async (userId, params = {}) => {
  return api.getApi().get(api.getBaseUrl() + `admin/users/${userId}/notifications`, { params });
};

